import { useEffect, useState } from "react";

const navLinks = [
  { href: "#updates", label: "最新更新" },
  { href: "#tracking", label: "追更功能" },
  { href: "#schedule", label: "更新周表" },
  { href: "#hot", label: "热门连载" },
  { href: "#genres", label: "内容分类" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 shadow-sm backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-black tracking-tight ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            虚空韩漫网
          </span>
        </a>

        <ul className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm font-medium transition-colors ${
                  scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-100 hover:text-accent-300"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#tracking"
            className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 px-5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
          >
            <i className="ri-notification-3-line text-base"></i>
            追更提醒
          </a>
          <a
            href="#updates"
            className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill text-base"></i>
            立即追更
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-4 flex gap-3">
            <a
              href="#tracking"
              onClick={() => setOpen(false)}
              className="inline-flex h-11 flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-300 text-sm font-medium text-primary-600"
            >
              <i className="ri-notification-3-line text-base"></i>
              追更提醒
            </a>
            <a
              href="#updates"
              onClick={() => setOpen(false)}
              className="inline-flex h-11 flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-sm font-medium text-background-50"
            >
              <i className="ri-flashlight-fill text-base"></i>
              立即追更
            </a>
          </div>
        </div>
      )}
    </header>
  );
}